import { render, staticRenderFns } from "./AccreditationRenew.vue?vue&type=template&id=80502e72"
import script from "./AccreditationRenew.vue?vue&type=script&lang=js"
export * from "./AccreditationRenew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports